import React from "react";
import { ClickAwayListener, MenuList } from "@material-ui/core";
import { useNavigate, useParams } from "react-router-dom";

import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import { makeStyles } from "@material-ui/core/styles";
import { useStudyPlan } from "../../../../app/contexts/study.context";

const OptionsMenu = ({
  isReadOnlyUser,
  anchor,
  open,
  studyPlanId,
  simOptRunId,
  scenarioStatus,
  studyPlanTypeDetail,
  onClone,
  onClose,
  onDelete,
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { id } = useParams();
  const { runSimulation } = useStudyPlan();

  const handleViewStudyPlan = () => {
    navigate(`/ctpo/study-plans/${id}/${studyPlanId}/review`);
    onClose();
  };

  const handleClone = () => {
    onClone();
    onClose();
  };

  const handleViewSimulation = () => {
    navigate(`/ctpo/study-plans/${id}/${studyPlanId}/simulation`);
    onClose();
  };

  const handleRunSimulation = () => {
    if (scenarioStatus === "Draft") {
      runSimulation(studyPlanId);
    }
    navigate(`/ctpo/study-plans/${id}/${studyPlanId}/simulation`);
  };

  const IsValidToCloneEnrollmentPlanType = () => {
    const noAvaliableToClone = ["Combination (R)", "Combination (D)"];
    return !noAvaliableToClone.includes(studyPlanTypeDetail);
  };

  return (
    <Popper
      open={open}
      anchorEl={anchor}
      placement="bottom-end"
    >
      <Paper classes={classes}>
        <ClickAwayListener onClickAway={onClose}>
          <MenuList
            autoFocusItem={open}
            id="composition-menu"
            aria-labelledby="composition-button"
            // onKeyDown={handleListKeyDown}
          >
            <MenuItem onClick={handleViewStudyPlan}>View Study Plan</MenuItem>
            {(simOptRunId === null && !isReadOnlyUser) && (
              <MenuItem onClick={handleRunSimulation}>
                Start Simulation
              </MenuItem>
            )}
            {simOptRunId !== null && (
              <MenuItem onClick={handleViewSimulation}>
                View Simulation
              </MenuItem>
            )}
            {(IsValidToCloneEnrollmentPlanType() && !isReadOnlyUser) && (
              <MenuItem onClick={handleClone}>Clone</MenuItem>
            )}
            {!isReadOnlyUser && (
              <MenuItem onClick={onDelete}>Delete</MenuItem>
            )}
          </MenuList>
        </ClickAwayListener>
      </Paper>
    </Popper>
  );
};

export default OptionsMenu;

const useStyles = makeStyles((theme) => ({
  root: {
    background: "var(--White)",
    border: "1px solid var(--surface-200)",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.15)",
    borderRadius: "4px",
    padding: "0",
  },
}));
